import { LogEntry, LogEntryRequest } from '../store/types/LoggerTypes';
import { conf } from 'config';

const LOG_URL = conf.proxyEndpoints.logs;

// Full-native http service for posting logs.
// The normal http service uses logger methods, which would cause an infinite loop.
export class LoggerHttpService {
  public static postLog(logEntry: LogEntry): void {
    const request = new XMLHttpRequest();

    try {
      request.open('POST', LOG_URL, true);
      request.setRequestHeader('Content-Type', 'application/json');

      request.onload = (): void => {
        if (request.status < 200 || request.status > 400) {
          console.error('Server rejected log:', LOG_URL, JSON.stringify(logEntry));
        }
      };

      request.onerror = (): void => {
        console.error('Error posting logs to hardware server.');
      };

      const body: LogEntryRequest = {
        data: {
          type: logEntry.severity,
          description: logEntry.payload,
        },
      };
      request.send(JSON.stringify(body));
    } catch (err) {
      if (err instanceof Error) {
        console.error('Something is wrong with the logger.', err.name, err.message, err.stack);
      } else {
        console.error('Something is wrong with the logger.', err);
      }
    }
  }
}
